import { useEffect, useState } from 'react';
import { Grid, TextField, Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import { getMoneyValues } from '@shared/services/services';
import { formatDateTimeStamp } from '@shared/helpers/formatDate';
import CustomMaterialTable from '@shared/components/MaterialTable';
import MaterialDialog from '@shared/components/Dialogs/MaterialDialog';

const initialData = {
  data: [],
  page: 1,
  per_page: 30,
  total: 0,
};

const initialParams = {
  date_from: '',
  page: 1,
  per_page: 30,
};

const Alert = props => <MuiAlert elevation={6} {...props} />;

const ExchangeRate = () => {
  const today = new Date();
  const formattedMonthYear = `${today.getFullYear()}-${String(
    today.getMonth() + 1
  ).padStart(2, '0')}`;

  const [dolarData, setDolarData] = useState(initialData);
  const [openDialog, setOpenDialog] = useState(false);
  const [openAlert, setOpenAlert] = useState({
    message: '',
    type: 'error',
    isVisible: false,
  });
  const [params, setParams] = useState(initialParams);

  // Columnas de la tabla
  const DolarTableColumns = [
    {
      title: 'Fecha desde',
      field: 'date_from',
      minWidth: 170,
      render: rowData => formatDateTimeStamp(rowData.date_from),
    },
    {
      title: 'GIT',
      field: 'git_value',
      minWidth: 170,
      render: rowData =>
        Number.parseFloat(rowData.git_value) > 0
          ? Number.parseFloat(rowData.git_value).toLocaleString('es-AR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          : 'Consultar',
    },
    {
      title: 'BSP',
      field: 'bsp_value',
      minWidth: 170,
      render: rowData =>
        Number.parseFloat(rowData.bsp_value).toLocaleString('es-AR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
    },
    {
      title: 'Descripción',
      field: 'descriptions',
      minWidth: 100,
    },
  ];

  // Función para traer los valores de dólar
  const fetchMoneyValuesData = async paramsToSend => {
    const date_from =
      paramsToSend.date_from === ''
        ? formattedMonthYear
        : paramsToSend.date_from;

    const finalParams = { ...paramsToSend, date_from };

    try {
      const result = await getMoneyValues(finalParams);

      const transformedData = result.data.map(row => ({
        ...row,
        bsp_value:
          row.bsp_value === null || row.bsp_value === '0.0000'
            ? 'Consultar'
            : row.bsp_value,
        git_value:
          row.git_value === null || row.git_value === '0.0000'
            ? 'Consultar'
            : row.git_value,
      }));

      setDolarData({ ...result, data: transformedData });
    } catch (error) {
      console.error('Error fetching dollar values:', error);
      setOpenAlert({
        message: 'Error al traer valores del dólar',
        type: 'error',
        isVisible: true,
      });
    }
  };

  const handleCloseAlert = () => {
    setOpenAlert({ ...openAlert, isVisible: false });
  };

  const handleChange = event => {
    setParams({
      ...params,
      [event.target.name]: event.target.value,
      page: 1,
    });
  };

  useEffect(() => {
    fetchMoneyValuesData(params);
  }, [params]);

  return (
    <Grid container justifyContent="center">
      <Grid item container xs={12} spacing={2} sx={{ mb: 2, mt: 2 }}>
        <Grid
          item
          xs={10}
          lg={5}
          container
          justifyContent="flex-start"
          sx={{ flexDirection: 'column-reverse' }}
        >
          <TextField
            fullWidth
            size="small"
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            type="month"
            label="Mes y año"
            name="date_from"
            value={params.date_from || formattedMonthYear}
            onChange={handleChange}
          />
        </Grid>

        <MaterialDialog
          isOpen={openDialog}
          handleIsOpen={setOpenDialog}
          handleConfirm={() => fetchMoneyValuesData(params)}
          actionsButton={false}
          maxWidth="lg"
          sxDialog={{ textAlign: 'left', marginLeft: 0, marginRight: 'auto' }}
          titleText="Agregar Dolar GIT"
        />

        <Snackbar
          open={openAlert.isVisible}
          autoHideDuration={3000}
          onClose={handleCloseAlert}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert onClose={handleCloseAlert} severity={openAlert.type}>
            {openAlert.message}
          </Alert>
        </Snackbar>
      </Grid>

      <Grid item xs={12}>
        <CustomMaterialTable
          title="Historial de Dolar"
          data={dolarData}
          columns={DolarTableColumns}
          onChangePage={page => setParams({ ...params, page })}
          options={{
            rowStyle: {
              fontFamily: 'Arial, sans-serif',
            },
          }}
        />
      </Grid>
    </Grid>
  );
};

export default ExchangeRate;
